import { render, staticRenderFns } from "./vertify.vue?vue&type=template&id=71a77d7d&scoped=true&"
import script from "./vertify.vue?vue&type=script&lang=js&"
export * from "./vertify.vue?vue&type=script&lang=js&"
import style0 from "./vertify.vue?vue&type=style&index=0&id=71a77d7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a77d7d",
  null
  
)

export default component.exports